import React, { useRef, useState } from 'react';
import FullScreenButton from '@components/fullScreenButton';
// import { INTEGRATION_TYPES } from '@model';
import TextContainer from '@components/textContainer/TextContainer';
// import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import { Loading } from '@components';
import { Button } from 'antd';
import useProjectId from '@hooks/useProjectId';
import useTextContainerService from '@hooks/useTextContainerService';

function TextContainerSection(props) {
  const {
    // type = INTEGRATION_TYPES.TEXT_CONTAINER,
    link,
    // propsLink,
    saveLink,
    section,
    setLink,
    identifier,
    // handleUserGuid,
    titleName,
    // hideEdit,
    // sectionOrder,
  } = props;
  const [editable, setEditable] = useState(false);
  const textContainerRef = useRef();
  const projectId = useProjectId();

  const { loading, data, saveData } = useTextContainerService(link);
  const handleSave = () => {
    const dataToSend = textContainerRef.current?.getData?.();
    if (dataToSend) {
      saveData({
        data: dataToSend,
        type: 'projectHome',
        id: data?.id,
        projectId,
      })
        .then((result) => {
          if (result?.id && result?.id !== link) {
            saveLink(section, result.id);
            setLink(result.id);
          }
          setEditable(false);
          if (textContainerRef.current?.setData && result.data) {
            textContainerRef.current.setData(
              result.data?.contents,
              result.data?.columnsWidthRatio,
            );
          }
        })
        .catch(console.log);
    }
  };
  const handleEdit = () => {
    setEditable(true);
  };
  const handleCancel = () => {
    setEditable(false);
    // eslint-disable-next-line no-unused-expressions
    textContainerRef.current?.setData?.(
      data?.data?.contents || [],
      data?.data?.columnsWidthRatio || [],
    );
  };

  return (
    <>
      <div className="powerbi-title-link text-container-section-title">
        <div className="left">
          <span className="title">{titleName}</span>
        </div>
        <div className="right">
          {editable ? (
            <>
              <Button
                className="dd-cancel-btn"
                onClick={handleCancel}
                loading={loading}
              >
                Cancel
              </Button>
              <Button
                className="edit-btn"
                type="primary"
                onClick={handleSave}
                loading={loading}
              >
                Save
              </Button>
            </>
          ) : (
            <Button
              type="primary"
              className="role-control edit-btn"
              onClick={handleEdit}
              loading={loading}
            >
              Edit Text
            </Button>
          )}
          <FullScreenButton
            elemId={`#fullscreen-${identifier}`}
            // onToggleFullScreen={() => setExpand((e) => !e)}
          />
        </div>
      </div>
      <div
        className="powerbi-fullscreen-div fix-ratio-div"
        id={`fullscreen-${identifier}`}
      >
        {loading ? (
          <Loading />
        ) : (
          <TextContainer
            ref={textContainerRef}
            editable={editable}
            initialValues={data?.data.contents}
            initialColumnRatio={data?.data.columnsWidthRatio}
          />
        )}
      </div>
    </>
  );
}

export default TextContainerSection;
